import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function tanquesvirtual(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@tanquesvirtual/FIND_TANQUESVIRTUAL':
      case '@tanquesvirtual/UPDATE_TANQUESVIRTUAL':
      case '@tanquesvirtual/DELETE_TANQUESVIRTUAL':
      case '@tanquesvirtual/STORE_TANQUESVIRTUAL':
      case '@tanquesvirtual/TANQUESVIRTUAIS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@tanquesvirtual/SUCCESS_REMOVE':
      case '@tanquesvirtual/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@tanquesvirtual/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.tanquesvirtuais;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@tanquesvirtual/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.tanquesvirtual;
        break;
      }

      case '@tanquesvirtual/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
